import React from 'react';
import MarketplaceCard from '../../../../components/MarketplaceCard/MarketplaceCard';

const ReviewCard = ({ listing }) => {
  return <MarketplaceCard listing={listing} variant="review" />;
};

export default ReviewCard;
